import { useTranslation } from "react-i18next";
import { ConfirmModal } from "@/components/ui";

interface HandshakeCancelSessionModalProps {
  isOpen: boolean;
  onClose: () => void;
  cancelSession: () => Promise<boolean>;
  isLoading?: boolean;
  intent?: "cancelSession" | "rejectBooking";
}

export function HandshakeCancelSessionModal({
  isOpen,
  onClose,
  cancelSession,
  isLoading = false,
  intent = "cancelSession",
}: HandshakeCancelSessionModalProps) {
  const { t: tCommon } = useTranslation("common");
  const { t } = useTranslation(["handshakePages", "common"]);

  const title =
    intent === "rejectBooking"
      ? t("rejectSessionTitle")
      : t("cancelSession");
  const message =
    intent === "rejectBooking" ? t("rejectSessionConfirm") : t("cancelConfirm");
  const confirmText =
    intent === "rejectBooking"
      ? t("rejectSessionAction")
      : t("cancelSession");

  return (
    <ConfirmModal
      closeLabel={tCommon("close")}
     
     
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={() => {
        void cancelSession().then((ok) => {
          if (ok) {
            onClose();
          }
        });
      }}
      title={title}
      message={message}
      confirmText={confirmText}
      cancelText={t("common:cancel")}
        isDestructive
      isLoading={isLoading}
    />
  );
}
